import React from "react";
import classes from "./classes.module.scss";

type IProps = {
	onClick?: () => void;
	variant?: "primary" | "secondary";
	sizing?: "s" | "m" | "l" | "xl" | "xxl";
	disabled?: boolean;
};

type IState = {};

export default class Button extends React.Component<IProps, IState> {
	static defaultProps: IProps = {
		variant: "primary",
		disabled: false,
		sizing: "l",
	};

	public render(): JSX.Element {
		return (
			<button {...this.props} className={classes["root"]}>
				{this.props.children}
			</button>
		);
	}
}
